import React, { FC, useContext, useState, useEffect, useMemo, useRef, memo } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import logo from '../beerxchange-logo-512.png';
import { LoginContext } from '../contexts/LoginContext';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import '../App.css';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { BeerXchangeUser } from '../types/model/beerXchangeUser';

interface Props {
  session: BeerXchangeUser;
}

type BxcNavState = {
  searchQuery: string;
};

const BxcNav: FC<Props> = () => {
  const { loggedInUntappdUser, loggedInUser, untappdAccessToken, logOutUser } =
    useContext(LoginContext);
  const navigate = useNavigate();
  const [state, setState] = useState<BxcNavState>({
    searchQuery: '',
  });
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const q = searchParams.get('q');
    if (q !== null) {
      setState({ searchQuery: q });
    }
  }, []);

  function updateSearch(event: React.ChangeEvent<HTMLInputElement>) {
    setState({ searchQuery: event.target.value });
  }

  function handleSubmit() {
    navigate('/search?q=' + state.searchQuery);
  }

  return (
    <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary">
      <Container>
        {loggedInUser && (
          <Navbar.Brand href={`/home/${loggedInUser.name}`}>
            <img src={logo} className="app_logo" alt="logo" />
          </Navbar.Brand>
        )}
        {!loggedInUser && (
          <Navbar.Brand href="/">
            <img src={logo} className="app_logo" alt="logo" />
          </Navbar.Brand>
        )}
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="/howto">HowTo</Nav.Link>
            <Nav.Link href="/users">Users</Nav.Link>
            {loggedInUser && <Nav.Link href="/collection">Collection</Nav.Link>}
            <Nav.Link href="/trades">Trades</Nav.Link>

            <Form className="search_form" onSubmit={handleSubmit}>
              <Row className="align-items-center">
                <Col>
                  <Form.Label htmlFor="SearchInput" visuallyHidden>
                    Search
                  </Form.Label>
                  <Form.Control
                    className="SearchInput"
                    id="SearchInput"
                    placeholder="Search beers and breweries"
                    value={state.searchQuery}
                    onChange={updateSearch}
                    name="q"
                  />
                </Col>
                <Col>
                  <Button type="submit" className="SearchSubmit" variant="dark">
                    Search
                  </Button>
                </Col>
              </Row>
            </Form>
          </Nav>
          {loggedInUser && (
            <NavDropdown title={loggedInUser.name} id="collapsible-profile-dropdown">
              <NavDropdown.Item href="/profile">Profile</NavDropdown.Item>
              <NavDropdown.Item href="/logout">Log out</NavDropdown.Item>
            </NavDropdown>
          )}
          {!loggedInUser && (
            <Nav>
              <Nav.Link href="/login">
                <Button className="LoginButton" variant="dark">
                  Login
                </Button>
              </Nav.Link>
            </Nav>
          )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default memo(BxcNav);
